import { ref as i, computed as o, watchEffect as y, createBlock as q, openBlock as b, withCtx as x, withDirectives as F, createElementVNode as L, normalizeClass as S, vModelDynamic as w } from "vue";
import { themeProp as B } from "../../../composables/useTheme.js";
import E from "../form-field-layout/form-field-layout.vue.js";
import { isValidFormField as V } from "../validation.js";
const z = ["id", "type", "name", "maxLength", "minLength"], $ = /* @__PURE__ */ Object.assign({
  name: "DsFormField",
  inheritAttrs: !1
}, {
  __name: "form-field",
  props: {
    ...B,
    /**
     * Field's label text
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Field's name
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Field type, optional
     */
    type: {
      type: String,
      default: "text",
      validator: (t) => ["text", "email", "tel", "url", "number"].includes(t)
    },
    /**
     * Field's value, optional
     */
    value: {
      type: String,
      default: ""
    },
    /**
     * Field's value max length, optional
     */
    maxLength: {
      type: String,
      default: "30"
    },
    /**
     * Field's value min length, optional
     */
    minLength: {
      type: String,
      default: "1"
    },
    /**
     * Field's error message text, optional
     */
    errorMessage: {
      type: String,
      default: ""
    },
    /**
     * Field is required, optional
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Field has error, force error state, optional
     */
    hasError: {
      type: Boolean,
      default: !1
    },
    /**
     * Field validation function, set custom validation
     */
    validate: {
      type: Function,
      default: null
    }
  },
  emits: ["value"],
  setup(t, { emit: d }) {
    const v = d, e = t, l = i(!1), a = i(e.value || ""), n = i(!1), f = o(() => !!a.value || l.value), c = o(() => e.type === "number" ? "text" : e.type), s = o(() => {
      switch (!0) {
        case e.type === "email":
          return /[^a-zA-Z0-9@._+-]/g;
        case e.type === "tel":
          return /[^+0-9]/g;
        case e.type === "url":
          return /[^-a-z0-9.:/]/g;
        case e.type === "number":
          return /[^0-9]/g;
        default:
          return null;
      }
    });
    y(() => {
      a.value = e.value, n.value = e.hasError;
    });
    function p(u) {
      const r = u.target.value;
      a.value = s.value ? r.replace(s.value, "") : r, v("value", a.value);
    }
    function g() {
      l.value && (l.value = !0, (e.required || e.validate) && (n.value = !V({
        value: a.value,
        validate: e.validate,
        required: e.required
      })), l.value = !1);
    }
    return (u, r) => (b(), q(E, {
      label: t.label,
      theme: u.theme,
      "is-active": f.value,
      required: t.required,
      "has-error": n.value,
      "error-message": t.errorMessage
    }, {
      default: x((h) => [
        F(L("input", {
          id: h.uid,
          "onUpdate:modelValue": r[0] || (r[0] = (m) => a.value = m),
          type: c.value,
          name: t.name,
          maxLength: t.maxLength,
          minLength: t.minLength,
          class: S([`ds-field--${u.theme}`, "ds-field"]),
          autocomplete: "off",
          "data-j-input": "",
          onFocus: r[1] || (r[1] = (m) => l.value = !0),
          onBlur: g,
          onInput: p
        }, null, 42, z), [
          [
            w,
            a.value,
            void 0,
            { trim: !0 }
          ]
        ])
      ]),
      _: 1
    }, 8, ["label", "theme", "is-active", "required", "has-error", "error-message"]));
  }
});
export {
  $ as default
};
